const rutasProyectoTorre2 = [
  // torre_2
  // torre_2_p1
  // torre_2_pisos
  // torre_2_ventanas
  // torre_2_balconesMuros
  // torre_2_balconesBarandas * tiene Alpha

  /// Modelos
  {
    name: "modelo_torre_2",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 02.gltf",
  },
  {
    name: "modelo_torre_2_cubierta",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 02_PISOS Y CUARTOS CUBIERTA.gltf",
  },
  {
    name: "modelo_torre_2_barandas",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 02_BALCONES_BARANDAS.gltf",
  },
  {
    name: "modelo_torre_2_rejilla",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 2_REJILLA.gltf",
  },
 
  ///Texturas  
  /*{
    name: "text_ejemplo",
    type: "texture",
    path: "texturas/proyecto/ejemplo.webp"
  },*/

  {
    name: "text_torre_2",
    type: "texture",
    path: "texturas/proyecto/nuevo/TORRE 02_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_cubierta",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 02_PISOS Y CUARTOS CUBIERTA_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_barandas",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 02_BALCONES_BARANDAS_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_barandas_alpha",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 02_BALCONES_BARANDAS_ALPHA.webp"
  },
  {
    name: "text_torre_2_rejilla",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE_2_REJILLA_Diffuse.webp"
  },
  {
    name: "text_torre_2_rejilla_alpha",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE_2_REJILLA_ALPHA.webp"
  },
];

export default rutasProyectoTorre2;
